// extracted by mini-css-extract-plugin
export var item = "fq_vj";
export var text = "fq_jg";